import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-579add62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid product-overview-bg pb-2" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "pt-3 pb-lg-1" }
const _hoisted_4 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_5 = { class: "lead" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-1 my-lg-2" }, null, -1))
const _hoisted_7 = { class: "d-flex flex-wrap justify-content-between flex-1" }
const _hoisted_8 = { class: "header-left justify-content-start justify-content-lg-start" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "header-right"
}
const _hoisted_12 = { class: "col-12 col-md-6 col-lg-4 col-xxl-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_DataViewLayoutOptions = _resolveComponent("DataViewLayoutOptions")!
  const _component_Message = _resolveComponent("Message")!
  const _component_ContentCategoryOverviewItemListCard = _resolveComponent("ContentCategoryOverviewItemListCard")!
  const _component_ContentCategoryOverviewItemSkeletonCard = _resolveComponent("ContentCategoryOverviewItemSkeletonCard")!
  const _component_ContentCategoryOverviewItemGridCard = _resolveComponent("ContentCategoryOverviewItemGridCard")!
  const _component_DataView = _resolveComponent("DataView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "breadcrumbs", {}, undefined, true),
        (_ctx.vm.gridViewTitle)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.vm.gridViewTitle), 1))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.vm.subtitle), 1),
        _hoisted_6
      ]),
      _createVNode(_component_DataView, {
        class: "w-100",
        layout: _ctx.viewLayout,
        lazy: true,
        paginator: true,
        rows: _ctx.filterStore.filter.pageSize,
        "total-records": _ctx.filterStore.filter.totalItems,
        value: _ctx.filterStore.overviewItems,
        onPage: _ctx.onPageChange
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeFilters, (filter, index) => {
                return (_openBlock(), _createBlock(_component_MultiSelect, {
                  key: index,
                  modelValue: _ctx.filterStore.filter[filter.model],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.filterStore.filter[filter.model]) = $event),
                  "append-to": "self",
                  class: "flex-grow-1 flex-lg-grow-0",
                  "option-value": "value",
                  options: filter.tags,
                  placeholder: filter.placeholder,
                  "scroll-height": "400px",
                  "show-toggle-all": false,
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filterStore.updateFilters()))
                }, {
                  value: _withCtx((slotProps) => [
                    (slotProps.value?.length === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("span", null, _toDisplayString(filter.tags.find((x) => x.value === slotProps.value[0])
															?.label), 1)
                        ]))
                      : (slotProps.value?.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("contentCategory.lblOptionSelected", {
														n: slotProps.value?.length,
													})), 1)
                          ]))
                        : _createCommentVNode("", true)
                  ]),
                  option: _withCtx((slotProps) => [
                    _createElementVNode("span", null, _toDisplayString(slotProps.option.label), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "options", "placeholder"]))
              }), 128))
            ]),
            (!_ctx.isSmallScreen)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_Dropdown, {
                    modelValue: _ctx.filterStore.sortType,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterStore.sortType) = $event)),
                    "option-label": "label",
                    "option-value": "value",
                    options: _ctx.filterStore.sortOptions,
                    "show-toggle-all": false,
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterStore.onSortChange()))
                  }, null, 8, ["modelValue", "options"]),
                  (!_ctx.isMobile)
                    ? (_openBlock(), _createBlock(_component_DataViewLayoutOptions, {
                        key: 0,
                        modelValue: _ctx.viewLayout,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.viewLayout) = $event)),
                        class: "ml-1"
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        empty: _withCtx(() => [
          _createVNode(_component_Message, {
            closable: false,
            severity: "warn"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("product.message.noOverviewItems")), 1)
            ]),
            _: 1
          })
        ]),
        list: _withCtx((item) => [
          (!_ctx.isSpinnerVisible('contentCategory'))
            ? (_openBlock(), _createBlock(_component_ContentCategoryOverviewItemListCard, {
                key: 0,
                item: item.data
              }, null, 8, ["item"]))
            : (_openBlock(), _createBlock(_component_ContentCategoryOverviewItemSkeletonCard, {
                key: 1,
                type: "list"
              }))
        ]),
        grid: _withCtx((item) => [
          _createElementVNode("div", _hoisted_12, [
            (!_ctx.isSpinnerVisible('contentCategory'))
              ? (_openBlock(), _createBlock(_component_ContentCategoryOverviewItemGridCard, {
                  key: 0,
                  item: item.data
                }, null, 8, ["item"]))
              : (_openBlock(), _createBlock(_component_ContentCategoryOverviewItemSkeletonCard, {
                  key: 1,
                  type: "grid"
                }))
          ])
        ]),
        _: 1
      }, 8, ["layout", "rows", "total-records", "value", "onPage"])
    ])
  ]))
}